import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { InputField } from '@/components/Form';
import { Button, Flex, Typography, theme } from 'antd';
import { useSendTFNUpdateOTPMutation } from '../../api/profileAPI';
import { displayError, displaySuccess } from '@/utils/displayMessageUtils';
import { FC } from 'react';
import { LockOutlined, SafetyCertificateOutlined } from '@ant-design/icons';

const { useToken } = theme;

const formSchema = yup.object().shape({
  tfnNumber: yup
    .string()
    .required('TFN Number is required')
    .matches(/^\d{8,9}$/, 'TFN must be 8 or 9 digits'),
});
export type FormType = yup.InferType<typeof formSchema>;

type TFNNumberEditProps = {
  handleTFNSumbit: () => void;
  refetchProfile: () => void;
};

const TFNNumberEdit: FC<TFNNumberEditProps> = ({ handleTFNSumbit }) => {
  const { token } = useToken();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormType>({
    resolver: yupResolver(formSchema),
  });

  const [sendTFNUpdateOTP, { isLoading }] = useSendTFNUpdateOTPMutation();

  const onSubmit = async (data: FormType) => {
    try {
      const res = await sendTFNUpdateOTP({
        tfn_number: data.tfnNumber,
      }).unwrap();
      displaySuccess(res?.message);
      handleTFNSumbit();
    } catch (err) {
      displayError(err);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Flex
        vertical
        align="center"
        gap={4}
        style={{ textAlign: 'center', marginBottom: 20 }}
      >
        <div
          style={{
            width: 48,
            height: 48,
            borderRadius: '50%',
            background: token.colorPrimaryBg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 4,
          }}
        >
          <LockOutlined style={{ fontSize: 20, color: token.colorPrimary }} />
        </div>
        <Typography.Text
          type="secondary"
          style={{ fontSize: 13, maxWidth: 320 }}
        >
          Enter your Tax File Number below. An OTP will be sent to verify the
          change.
        </Typography.Text>
      </Flex>

      <InputField
        name="tfnNumber"
        control={control}
        label="TFN Number"
        size="large"
        required
        placeholder="Enter your 8 or 9 digit TFN"
        error={errors?.tfnNumber?.message ?? ''}
        type="password"
      />

      <Button
        type="primary"
        htmlType="submit"
        size="large"
        block
        loading={isLoading}
        icon={<SafetyCertificateOutlined />}
        style={{ marginTop: 8, height: 44, fontWeight: 500 }}
      >
        Verify & Save
      </Button>
    </form>
  );
};

export default TFNNumberEdit;
